import { default as Page, loader } from './page'

export default Page

export { loader }
